/*=============================================== ShadowPage ===============================================*/

import { Grid, useMaxWidth } from "tsx-library-julseb"

import { ComponentsLayout, CardStyles } from "components"

import { allShadows } from "data"

const ShadowsPage = () => {
    const isMobile = useMaxWidth(600)

    return (
        <ComponentsLayout>
            <Grid col={isMobile ? 1 : 3} gap="s">
                {allShadows.map(s => (
                    <CardStyles shadow={s} key={s.name} />
                ))}
            </Grid>
        </ComponentsLayout>
    )
}

export default ShadowsPage
